// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_82-0";